import { android, firefox } from '@rambler-id/browser';
let authenticatorAvailable = false;
export const checkWebAuthnAvailability = async () => {
    try {
        if (!window.PublicKeyCredential) {
            return;
        }
        if (!checkWebAuthnAvailability.promise) {
            checkWebAuthnAvailability.promise =
                window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
        }
        authenticatorAvailable = await checkWebAuthnAvailability.promise;
    }
    catch { }
};
export const getWebAuthnAvailability = ({ withUserVerifying } = {}) => {
    try {
        if (!withUserVerifying) {
            return !!window.PublicKeyCredential;
        }
        return authenticatorAvailable || (android && firefox);
    }
    catch {
        return false;
    }
};
